/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { WrapReactiveFormControls } from '@common/types/form';
import { Angulartics2OnModule } from 'angulartics2';

export interface PromptData {
  message?: string;
  placeholder?: string;
  value?: string;
  title?: string;
  dismissButtonLabel?: string;
  submitButtonLabel?: string;
}
type FormModel = Pick<PromptData, 'value'>;

@Component({
  selector: 'dialog-prompt',
  templateUrl: './dialog-prompt.component.html',
  styleUrls: ['./dialog-prompt.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    Angulartics2OnModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
})
export class DialogPromptComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PromptData,
    private dialog: MatDialogRef<DialogPromptComponent, string | undefined | null>,
  ) {}

  form = new FormGroup<WrapReactiveFormControls<FormModel>>({
    value: new FormControl(this.data.value, { nonNullable: true }),
  });

  onSubmit() {
    this.dialog.close(this.form.value.value);
  }
}
